import { render } from "./invite.vue?vue&type=template&id=0c465813&ts=true"
import script from "./invite.vue?vue&type=script&lang=ts"
export * from "./invite.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageTypes/invite.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c465813"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c465813', __exports__)) {
    api.reload('0c465813', __exports__)
  }
  
  module.hot.accept("./invite.vue?vue&type=template&id=0c465813&ts=true", () => {
    api.rerender('0c465813', render)
  })

}


export default __exports__